import {
    DateScrollerRange,
} from '../../../../../components/kit/input/date-scroller-input-v2/date-scroller-input.types';
import { DashboardChartTooltipPosition } from './dashboard-chart-tooltip/dashboard-chart-tooltip.types';

export function dashboardServiceIds(items: readonly { serviceId: string }[]): number[] {
    return [...new Set(items.map(item => Number(item.serviceId)).filter(Number.isFinite))];
}

export function dashboardDateKey(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function dashboardPeriodDateKeys(period: DateScrollerRange): string[] {
    const keys: string[] = [];
    const current = new Date(period.dateFrom);
    current.setHours(0, 0, 0, 0);
    const end = new Date(period.dateTo);
    end.setHours(0, 0, 0, 0);

    while (current <= end) {
        keys.push(dashboardDateKey(current));
        current.setDate(current.getDate() + 1);
    }

    return keys;
}

export function dashboardShiftMinutes(intervals: readonly { startMinutes: number; endMinutes: number }[]): number {
    return intervals.reduce((total, interval) => total + Math.max(0, interval.endMinutes - interval.startMinutes), 0);
}

export function dashboardChartTooltipPosition(
    chartWidth: number,
    chartHeight: number,
    x: number,
    y: number,
): DashboardChartTooltipPosition {
    return {
        x,
        y,
        horizontalAlign: x > chartWidth * 2 / 3 ? 'right' : 'left',
        verticalAlign: y < chartHeight / 2 ? 'below' : 'above',
    };
}
